(ns frontend.view.nev.surveys.survey-process
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.entities.survey.survey-process-status :as survey-process-status]
   [common.sync-progress :as sync-progress]
   [frontend.actions.entity :as entity-actions]
   [frontend.intercom :as intercom]
   [frontend.logging :as logging]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.nev.events :as nev-events]
   [frontend.view.nev.surveys.form.events :as events]
   [frontend.view.nev.surveys.form.status-approved :as status-approved]
   [frontend.view.nev.surveys.form.status-approved-modified :as status-approved-modified]
   [frontend.view.nev.surveys.form.status-draft :as status-draft]
   [frontend.view.nev.surveys.form.status-prefilled :as status-prefilled]
   [frontend.view.nev.surveys.form.status-submitted :as status-submitted]
   [frontend.view.nev.surveys.form.status-template :as status-template]
   [frontend.view.nev.surveys.form.status-wip :as status-wip]
   [frontend.view.nev.surveys.form.sub :as sub]
   [frontend.view.syncing-data :as syncing-data]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.alert.view :as alert]))

(defn confirm-state-change
  [entity new-status on-success!]
  (modals/open-modal!
   confirmation-modal/modal-key
   {:body           (case new-status
                      :survey-process.status/wip
                      [:div
                       {:class "flex flex-col gap-6 text-regular items-baseline"}
                       [alert/warning
                        {}
                        [:p
                         {:class "font-semibold text-md leading-6"}
                        (loc/tr :changing-the-status-to) [:strong.inline-block.px-2.font-bold (str "'" (loc/tr new-status) "'")] (loc/tr :change-status-back-to-wip-content)]]]

                      [:div
                       {:class "flex flex-col gap-6 text-regular"}
                       [alert/warning
                        {}
                        [:p
                         {:class "font-semibold text-md leading-6"}
                         (loc/tr :changing-the-status-to) [:strong.inline-block.px-2.font-bold (str "'" (loc/tr new-status) "'")] (loc/tr :change-status-back-to-content)]]])
    :skip-checkbox? true
    :body-class     "text"
    :confirm-text   (case new-status
                      :survey-process.status/wip
                      [:span (loc/tr :change-status-back-to-wip)]
                      :survey-process.status/submitted
                      [:span (loc/tr :change-status-back-to-under-review)]
                      :survey-process.status/prefilled
                      [:span (loc/tr :change-status-back-to-prefilled)]
                      :survey-process.status/draft
                      [:span (loc/tr :change-status-back-to-draft)]
                      [:span (loc/tr :yes)])
    :on-confirm     (fn [_]
                      (entity-actions/*->field-update!
                       (:db/id entity)
                       :survey-process/status
                       new-status
                       on-success!
                       (fn [err]
                         (logging/error "Failed to update survey process status " err))))}))

(defn clickable?
  [survey-process opt]
  (and (< (->> :survey-process.status/template
               (survey-process-status/get-option)
               :ord)
          (:ord opt)
          (->> survey-process
               :survey-process/status
               (survey-process-status/get-option)
               :ord))))

;;STEPS COMPONENT FROM TAILWIND LIBRARY
(defn status-item
  [opt current-status-opt click-handler]
  (let [status (cond
                 (< (:ord opt) (:ord current-status-opt))
                 "Completed"
                 (= (:ord opt) (:ord current-status-opt))
                 "In progress"
                 :else
                 "Pending")]
    [:li {:class (str "px-0.5 lg:px-0 w-full relative text-base-light-text lg:after:content-['']  lg:after:w-full lg:after:h-0.5  lg:after:bg-base-regular lg:after:inline-block lg:after:absolute lg:after:top-3 lg:after:left-2/4 lg:last:after:content-none")}
     ;;Status icon and line
     [:div
      {:class "relative flex flex-col gap-1.5 flex-col-reverse lg:block lg:text-center z-10 "}
      (cond
        (= status "Completed")
        [:<>
         [:div {:on-click (partial click-handler opt)
                :class    "relative inline-flex h-1.5 w-full lg:h-6 lg:w-6 items-center justify-center rounded-full bg-primary-regular hover:bg-secondary-regular"}
          [:span {:class "h-5 w-5 rounded-full bg-primary-regular hidden lg:flex items-center justify-center"}
           [:i {:class "fal fa-check text-primary-regular-text"}]]]]

        (= status "In progress")
        [:<>
         [:div {:on-click (partial click-handler opt)
                :class    "relative inline-flex h-1.5 w-full lg:h-6 lg:w-6 items-center justify-center rounded-full border border-solid border-primary-regular bg-base-light"}
          [:span {:class "rounded-full hidden lg:flex items-center justify-center"}
           [:i {:class "fas fa-circle text-primary-regular"}]]]]

        :else
        [:<>
         [:div {:on-click (partial click-handler opt)
                :class    "group relative inline-flex h-1.5 w-full lg:h-6 lg:w-6 items-center justify-center rounded-full bg-base-gloomy border border-gray-300 hover:border-gray-400"}
          [:span {:class " hidden lg:flex h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300"}]]])
      ;;Status texts
      [:div {:class "flex flex-col gap-1"}
       ;;[:p {:class "text-xs"} (str "Step " (:ord opt))]
       [:div
        {:class "m-0 pt-1.5 font-semibold leading-3 text-xs md:text-sm"}
        (:label opt)]
      ;;  [:p {:class "hidden md:block text-xs leading-3 text-base-light-text-paler"} status]
       ]]]))


(defn status
  [entity profile]
  (let [current-status-opt (survey-process-status/get-option (:survey-process/status entity))
        click-handler (fn [opt]
                        (when (clickable? entity opt)
                          (confirm-state-change entity
                                                (:key opt)
                                                #(rf/dispatch [::events/load-editor-process (:db/id entity) (:db/id profile)]))))
        labels (:survey-process/localized-labels entity)]
    [:<>
     [:div
      {:class "p-3 mb-4 max-w-full flex flex-row gap-4 justify-center bg-complement-light"}
      [:div 
       [:span
        {:class "block text-bold text-xl text-center"}
        (entity/display-string (session/get-entity (:survey-profile/target profile)))]
       [:span
        {:class "block text-center"}
        (or (:ENG labels) 
            (->> labels
                 (vals)
                 (first)))]]]
     [:div
      {:class "py-3 max-w-full flex md:justify-center bg-base-light"}                               ;; removed overflow-auto @anna, this breaks the flex
      [:ul
       {:class "px-2 flex gap-0.5 lg:gap-0 items-start md:items-center w-full lg:min-w-[1040px] text-xs text-base-light-text font-medium sm:text-base"}
       (->> survey-process-status/options
            (sort-by :ord)
            (map (fn [opt]
                   [status-item opt current-status-opt click-handler]
                   #_[:li
                      {:key        (str "survey-process-indicator-" (name (:key opt)))
                       :class-name (fu/cs "flex flex-col items-center text-xs"
                                          (when (<= (:ord opt) (:ord current-status-opt))
                                            "")
                                          (when (clickable? entity opt)
                                            "clickable"))
                       :on-click   (partial click-handler opt)}
                      [:i
                       ;Mikko Pls check logic for icon
                       {:class-name (fu/cs "flex flex-col items-center fas fa-circle text-2xl"
                                           (when (<= (:ord opt) (:ord current-status-opt))
                                             "fas fa-check-circle text-2xl")
                                           (when (clickable? entity opt)
                                             ""))}]
                      (->> opt
                           :label)]))
            (doall))]]]))

(defn survey-process-view
  [{:keys [survey-process-id survey-profile-id]}]
  (r/create-class
   {:component-did-mount
    (fn [_]
      (intercom/hide)
      (js/console.log "Mount survey : " survey-process-id)
      (rf/dispatch [::events/load-editor-process survey-process-id survey-profile-id])
      (nev-events/subscribe-to-changes! {:entity      {:db/id survey-process-id}
                                         :on-updates! (fn [entities]
                                                        (rf/dispatch [::events/process-updates survey-process-id entities])
                                                        (nev-events/updates-to-session-state entities))}))
    :component-will-unmount
    (fn [_]
      (intercom/show)
      (nev-events/unsubscribe-changes! {:entity {:db/id survey-process-id}}))
    :reagent-render
    (fn [_]
      (let [survey-process @(rf/subscribe [::sub/survey-process])
            survey-profile @(rf/subscribe [::sub/survey-profile])]
        [:<>
         #_[:span (pr-str survey-process)]
         (if (empty? survey-process)
           [syncing-data/view]
           (let [;; do not override with empty answers or nil answers
                 ;; Investigate why IndexedDb is cleared or corrupted ??
                 ]
             [:div
              {:class "flex flex-col h-full w-full max-h-full max-w-full overflow-hidden bg-base-light"}
              [status survey-process survey-profile]
              (case (:survey-process/status survey-process)
                :survey-process.status/template
                [:<>
                 [status-template/view]]
                :survey-process.status/draft
                [:<>
                 [status-draft/view]
                 [status-draft/footer]]

                :survey-process.status/prefilled
                [status-prefilled/view]
                :survey-process.status/wip
                [:<>
                 [status-wip/view]
                 [status-wip/footer]]
                :survey-process.status/submitted
                [:<>
                 [status-submitted/view]
                 [status-submitted/footer]]
                :survey-process.status/approved
                [:<>
                 [status-approved/view]
                 [status-approved/footer]]
                :survey-process.status/approved-modified
                [:<>
                 [status-approved-modified/view]
                 [status-approved-modified/footer]]
                [syncing-data/view])]))]))}))

(defn component
  [survey-process-id survey-profile-id]
  [syncing-data/wait-until-sync-progress sync-progress/BASE
   [survey-process-view
    {:survey-process-id survey-process-id
     :survey-profile-id survey-profile-id}]])

(defmethod routing/render-view :entity.type/survey-process
  [{:keys [route-params _view-params]}]
  (let [survey-process-id (-> route-params
                              :id
                              js/parseInt)
        survey-profile-id (-> route-params
                              :profile-id
                              js/parseInt)]
    ;;the key change forces rerendering of the component (and its child components)
    ^{:key (str "survey-process-viewer-id-" survey-process-id)}
    [component survey-process-id survey-profile-id]))
